import { makeStyles } from "@mui/styles";
import { visuallyHidden } from "@mui/utils";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import React from "react";
import { useParams } from "react-router-dom";
import ConfigLogo from "../../components/config-logo";
import DarkBox from "../../components/dark-box";
import FrameControls from "../../components/frame-controls";
import LoginForm from "./login-form";

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(7, 2),
    boxSizing: "border-box",
  },
  box: {
    width: "340px",
    padding: theme.spacing(2.5),
    position: "relative",
    maxWidth: "100%",
    borderRadius: "4px",
    [theme.breakpoints.up("sm")]: {
      width: "540px",
    },
  },
  popupBox: {
    paddingBottom: "16px",
  },
}));

const LoginView = ({ fullWidth }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { samlTokenId, oidcTokenId } = useParams();

  return (
    <>
      <FrameControls />
      <div className={fullWidth ? undefined : classes.page}>
        <DarkBox
          role="main"
          className={fullWidth ? classes.popupBox : classes.box}
        >
          <h1 style={visuallyHidden}>{t("LOGIN")} — Code10 Nexus</h1>
          <ConfigLogo
            alt="Code10 Nexus"
            configKey={"logo"}
            defaultLogo={"img/nexus-key-lockup.svg"}
            height="100%"
          />
          <a
            href="help.html"
            target="_blank"
            rel="noopener"
            className="infolabel"
            aria-label={t("NEXUS_PROVIDER_INFO")}
          >
            <i className="fa fa-info-circle" aria-hidden="true" />
          </a>
          <LoginForm
            samlTokenId={samlTokenId}
            oidcTokenId={oidcTokenId}
            fullWidth={fullWidth}
          />
        </DarkBox>
      </div>
    </>
  );
};

LoginView.defaultProps = {
  fullWidth: false,
};
LoginView.propTypes = {
  fullWidth: PropTypes.bool,
};

export default LoginView;
